import { render, staticRenderFns } from "./BrightnessCurve.vue?vue&type=template&id=54b124cc&lang=html&"
import script from "./BrightnessCurve.vue?vue&type=script&lang=js&"
export * from "./BrightnessCurve.vue?vue&type=script&lang=js&"
import style0 from "./BrightnessCurve.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports